export default "__VITE_ASSET__D4R7hHcZ__"